import { Singleton } from '../data-structures/Singleton';

export function Service<T>(): any {
    abstract class ServiceClass extends Singleton<T>() {}

    return ServiceClass as any;
}
